export const USStateOptions = [
  { label: 'Armed Forces Americas', value: 'AA' },
  { label: 'Armed Forces Europe', value: 'AE' },
  { label: 'Alaska', value: 'AK' },
  { label: 'Alabama', value: 'AL' },
  { label: 'Armed Forces Pacific', value: 'AP' },
  { label: 'Arkansas', value: 'AR' },
  { label: 'American Samoa', value: 'AS' },
  { label: 'Arizona', value: 'AZ' },
  { label: 'California', value: 'CA' },
  { label: 'Colorado', value: 'CO' },
  { label: 'Connecticut', value: 'CT' },
  { label: 'District of Columbia', value: 'DC' },
  { label: 'Delaware', value: 'DE' },
  { label: 'Florida', value: 'FL' },
  { label: 'Georgia', value: 'GA' },
  { label: 'Guam', value: 'GU' },
  { label: 'Hawaii', value: 'HI' },
  { label: 'Iowa', value: 'IA' },
  { label: 'Idaho', value: 'ID' },
  { label: 'Illinois', value: 'IL' },
  { label: 'Indiana', value: 'IN' },
  { label: 'Kansas', value: 'KS' },
  { label: 'Kentucky', value: 'KY' },
  { label: 'Louisiana', value: 'LA' },
  { label: 'Massachusetts', value: 'MA' },
  { label: 'Maryland', value: 'MD' },
  { label: 'Maine', value: 'ME' },
  { label: 'Michigan', value: 'MI' },
  { label: 'Minnesota', value: 'MN' },
  { label: 'Missouri', value: 'MO' },
  { label: 'Northern Mariana Islands', value: 'MP' },
  { label: 'Mississippi', value: 'MS' },
  { label: 'Montana', value: 'MT' },
  { label: 'North Carolina', value: 'NC' },
  { label: 'North Dakota', value: 'ND' },
  { label: 'Nebraska', value: 'NE' },
  { label: 'New Hampshire', value: 'NH' },
  { label: 'New Jersey', value: 'NJ' },
  { label: 'New Mexico', value: 'NM' },
  { label: 'Nevada', value: 'NV' },
  { label: 'New York', value: 'NY' },
  { label: 'Ohio', value: 'OH' },
  { label: 'Oklahoma', value: 'OK' },
  { label: 'Oregon', value: 'OR' },
  { label: 'Pennsylvania', value: 'PA' },
  { label: 'Puerto Rico', value: 'PR' },
  { label: 'Rhode Island', value: 'RI' },
  { label: 'South Carolina', value: 'SC' },
  { label: 'South Dakota', value: 'SD' },
  { label: 'Tennessee', value: 'TN' },
  { label: 'Trusted Territories', value: 'TT' },
  { label: 'Texas', value: 'TX' },
  { label: 'United States Minor Outlying Islands', value: 'UM' },
  { label: 'Utah', value: 'UT' },
  { label: 'Virginia', value: 'VA' },
  { label: 'Virgin Islands, U.S.', value: 'VI' },
  { label: 'Vermont', value: 'VT' },
  { label: 'Washington', value: 'WA' },
  { label: 'Wisconsin', value: 'WI' },
  { label: 'West Virginia', value: 'WV' },
  { label: 'Wyoming', value: 'WY' }
];

export const IsValidStateAbbrev = (abbrev: string): boolean => USStateOptions.map((options) => options.value).includes(abbrev.toLocaleUpperCase());

/**
 * Use this to get state longName from abbreviations more efficiently than with Array.find().
 *
 * ex. stateAbbrevMap['OH'] gets you 'Ohio'
 */

export const USStateAbbrevMap: { [abbrev: string]: string; } =
  USStateOptions.reduce((memo: { [abbrev: string]: string; }, option) => {
    // eslint-disable-next-line no-param-reassign
    memo[option.value] = option.label;
    return memo;
  }, {});

export const USStateNameMap: { name: string; value: string; }[] =
  USStateOptions.reduce((memo: { name: string; value: string; }[], option) => {
    memo.push({ name: option.label, value: option.value });
    return memo;
  }, []);
